import React, { type FC, memo } from 'react';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';

import styles from './SummerPromo2026BackgroundImages.css';

interface Props {
    isMobile: boolean;
    isWebview?: boolean;
}

export const SummerPromo2026BackgroundImages: FC<Props> = memo(function SummerPromo2026BackgroundImages(props) {
    const { isMobile, isWebview } = props;

    if (isWebview) {
        return (
            <>
                <img src={`${cdnPackagesUrl}/static/cloud/promo/summer2026/right-webview.webp`} className={styles.rightWebviewImg} />
            </>
        );
    }

    if (isMobile) {
        return (
            <>
                <img src={`${cdnPackagesUrl}/static/cloud/promo/summer2026/left-mobile.webp`} className={styles.leftMobImg} />
                <img src={`${cdnPackagesUrl}/static/cloud/promo/summer2026/right-mobile.webp`} className={styles.rightMobImg} />
            </>
        );
    }

    return (
        <>
            <img src={`${cdnPackagesUrl}/static/cloud/promo/summer2026/left-desktop-new.webp`} className={styles.leftImg} />
            <img src={`${cdnPackagesUrl}/static/cloud/promo/summer2026/right-desktop.webp`} className={styles.rightImg} />
        </>
    );
});
